import Handlebars from "@cirrus/legacy/vendor-bower/handlebars/handlebars"

Handlebars.registerHelper("img", (relativeUrl, optionName) => {
  var imageUrl = Url.resize(relativeUrl, optionName)
  return new Handlebars.SafeString(imageUrl)
})
